import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Status, Asset, LearnspaceMode } from '@shared/models';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { FileManagerComponent } from '@shared/components/file-manager/file-manager.component';
import { filter } from 'rxjs/operators';
import { AssetType } from '@shared/models/assetType.model';
import { CurrentContextService } from '@shared/services/currentContextService';
import { spaceLabel, StringCase } from '@shared/utils/wording.utils';
@Component({
  selector: 'learnspace-edit-dialog',
  templateUrl: './learnspace-edit-dialog.component.html',
  styleUrls: ['./learnspace-edit-dialog.component.scss']
})
export class LearnspaceEditDialogComponent implements OnInit {
  lsForm: FormGroup;
  asset: Asset;
  statusList = Object.values(Status);
  fileManager: MatDialogRef<FileManagerComponent>;
  title: string;
  mode?: LearnspaceMode;

  constructor(
    public _dialogRef: MatDialogRef<LearnspaceEditDialogComponent>,
    private _courseApiService: CoursesAPIService,
    private _dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public _data: any //TODO declare model
  ) {
    this.lsForm = new FormGroup({
      title: new FormControl('', { validators: [Validators.required, Validators.maxLength(50)] }),
      description: new FormControl(''),
      status: new FormControl('draft'),
      postermedia_id: new FormControl('', { validators: [Validators.required] }),
      hub_id: new FormControl('')
    });
  }

  ngOnInit(): void {
    if (this._data) {
      if (this._data.learnspace) {
        this.mode = this._data.learnspace.mode;
        this.title = `${spaceLabel(this.mode, false, StringCase.capitalcase)} Edition`
        this.lsForm.reset(this._data.learnspace);
        this.asset = this._data.learnspace.postermedia;
      } else {
        this.mode = this._data.mode;
        this.title = `Create a New ${spaceLabel(this.mode, false, StringCase.capitalcase)}`;
        this.lsForm.controls['hub_id'].setValue(this._data.hubId);
      }
    }
  }

  saveAndCloseDialog(): void {
    let query;
    if (this._data && this._data.learnspace){
      // Update the current object directly to update LS list
      Object.assign(this._data.learnspace, this.lsForm.value);
      query = this._courseApiService.updateLearnspace(this._data.learnspace.id, this.lsForm.value);
    }
    else{
      const lsData = {
        ...this.lsForm.value,
        mode: this._data.mode
      };
      query = this._courseApiService.createLearnspace(lsData);
    }
    query.subscribe(ls => {
      this._dialogRef.close(ls);
    });
  }
  newPoster(asset: Asset): void {
    this.asset = asset;
    if (this._data && this._data.learnspace) {
      if (!this._data.learnspace.postermedia) {
        this._data.learnspace.postermedia = this.asset;
      } else {
        Object.assign(this._data.learnspace.postermedia, asset);
      }
    }
    this.lsForm.controls.postermedia_id.setValue(asset.id);
  }
  onOpenFileManager(): void {
    this.fileManager = this._dialog.open(FileManagerComponent, {
      panelClass: 'learnspace-theme',
      data: {
        title: 'Poster Image',
        type: AssetType.i2D,
        openOnTab: 0,
        learnspaceId: this._data.learnspace?.id
      },
      id: 'file-manager'
    });
    this.fileManager
      .afterClosed()
      .pipe(
        filter(event => event !== undefined)
      )
      .subscribe(val => {
        this.newPoster(val);
      });
  }
  openHelp(): void{
    window.open('https://help.spaces.wondavr.com/en/articles/2491421-create-and-edit-a-team-space');
  }

}
